// The "Transcript (TXT)" export: the ticked clips as a plain text document, made in the
// browser (nothing goes to the server). One line per clip — time, speaker, words — with the
// ET's ✏ edits already applied by the caller.

export const formatClock = (seconds) => {
  const total = Math.floor(Math.max(0, Number(seconds) || 0));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = String(total % 60).padStart(2, '0');
  return h ? `${h}:${String(m).padStart(2, '0')}:${s}` : `${m}:${s}`;
};

// AssemblyAI speakers come as a bare letter ("A ", "B"); a renamed speaker is a real name.
const speakerName = (speaker) => {
  const name = String(speaker || '').trim();
  if (!name) return '';
  return /^[A-Z]$/.test(name) ? `Speaker ${name}` : name;
};

/** clips: [{ start (seconds), speaker, text }] in export order. */
export const buildTranscriptText = (title, clips) => {
  const lines = clips.map((c) => {
    const who = speakerName(c.speaker);
    return `[${formatClock(c.start)}] ${who ? `${who}: ` : ''}${(c.text || '').trim()}`;
  });
  const head = (title || '').trim() ? `${title.trim()}\n\n` : '';
  return `${head}${lines.join('\n')}\n`;
};
